module.exports = __webpack_public_path__ + "img/student_documents.fba1fa91.png";